import ImageComponent from '@kvass/media-render/Types/Image'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ImageComponent
  }
}
